// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v2/token.proto (package infinigence.infini.agentplatform.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v2/token.proto.
 */
export const file_agentplatform_v2_token: GenFile = /*@__PURE__*/
  fileDesc("ChxhZ2VudHBsYXRmb3JtL3YyL3Rva2VuLnByb3RvEiNpbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MiKVBAoKQWdlbnRUb2tlbhIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEjwKBHR5cGUYAyABKA4yLi5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52Mi5Ub2tlblR5cGUSLAoRYWdlbnRfaW5zdGFuY2VfaWQYBCABKAlSEWFnZW50X2luc3RhbmNlX2lkEi4KEmNoYW5uZWxfYWNjb3VudF9pZBgFIAEoCVISY2hhbm5lbF9hY2NvdW50X2lkEkAKBnN0YXR1cxgGIAEoDjIwLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYyLlRva2VuU3RhdHVzEhwKCWV4cGlyZV9hdBgHIAEoA1IJZXhwaXJlX2F0Eg0KBXRva2VuGAggASgJEiIKDGxhc3RfdXNlZF9hdBgJIAEoA1IMbGFzdF91c2VkX2F0EiYKDnJlZ2VuZXJhdGVkX2F0GAogASgDUg5yZWdlbmVyYXRlZF9hdBIcCgl0ZW5hbnRfaWQYCyABKAlSCXRlbmFudF9pZBIYCgd1c2VyX2lkGAwgASgJUgd1c2VyX2lkEh4KCmNyZWF0ZWRfYXQYDSABKANSCmNyZWF0ZWRfYXQSHgoKdXBkYXRlZF9hdBgOIAEoA1IKdXBkYXRlZF9hdBIeCgpkZWxldGVkX2F0GA8gASgDUgpkZWxldGVkX2F0Kj8KCVRva2VuVHlwZRIaChZUT0tFTl9UWVBFX1VOU1BFQ0lGSUVEEAASBwoDQVBJEAESDQoJV0VCU09DS0VUEAIqUwoLVG9rZW5TdGF0dXMSHAoYVE9LRU5fU1RBVFVTX1VOU1BFQ0lGSUVEEAASCwoHRU5BQkxFRBABEgwKCERJU0FCTEVEEAISCwoHRVhQSVJFRBADQklaR2dpdGxhYi5pbmZpbmktYWkuY29tL21pemFyL2luZmluaWFpLWFnZW50aWMtaW5mcmEvY29tbW9uL2dycGNhcGlzL3YyO3YyYgZwcm90bzM");

/**
 * AgentToken 为指定 Agent 实例创建的 API / WebSocket 渠道访问凭证
 *
 * @generated from message infinigence.infini.agentplatform.v2.AgentToken
 */
export type AgentToken = Message<"infinigence.infini.agentplatform.v2.AgentToken"> & {
  /**
   * 记录 ID（内部唯一标识，非 token 明文）
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Token 名称，用户可读
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Token 类型（前缀由类型推导：API->agt_，WEBSOCKET->wst_）
   * @gotags: json:"type"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.TokenType type = 3;
   */
  type: TokenType;

  /**
   * 绑定的 Agent 实例 ID
   * @gotags: json:"agent_instance_id"
   *
   * @generated from field: string agent_instance_id = 4 [json_name = "agent_instance_id"];
   */
  agentInstanceId: string;

  /**
   * 绑定的 WebSocket 渠道账号 ID（仅 WEBSOCKET 类型有值）
   * @gotags: json:"channel_account_id,omitempty"
   *
   * @generated from field: string channel_account_id = 5 [json_name = "channel_account_id"];
   */
  channelAccountId: string;

  /**
   * 启停状态
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.TokenStatus status = 6;
   */
  status: TokenStatus;

  /**
   * 有效期截止时间（unix nano，0 表示永久有效）
   * @gotags: json:"expire_at,omitempty"
   *
   * @generated from field: int64 expire_at = 7 [json_name = "expire_at"];
   */
  expireAt: bigint;

  /**
   * Token 脱敏展示值
   * @gotags: json:"token"
   *
   * @generated from field: string token = 8;
   */
  token: string;

  /**
   * 最近一次使用时间（unix nano）
   * @gotags: json:"last_used_at,omitempty"
   *
   * @generated from field: int64 last_used_at = 9 [json_name = "last_used_at"];
   */
  lastUsedAt: bigint;

  /**
   * 最近一次重新生成时间（unix nano）
   * @gotags: json:"regenerated_at,omitempty"
   *
   * @generated from field: int64 regenerated_at = 10 [json_name = "regenerated_at"];
   */
  regeneratedAt: bigint;

  /**
   * 所属租户
   * @gotags: json:"tenant_id"
   *
   * @generated from field: string tenant_id = 11 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 创建者用户 ID
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 12 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 创建时间（unix nano）
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 13 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间（unix nano）
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 14 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 删除时间（unix nano，软删）
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 15 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v2.AgentToken.
 * Use `create(AgentTokenSchema)` to create a new message.
 */
export const AgentTokenSchema: GenMessage<AgentToken> = /*@__PURE__*/
  messageDesc(file_agentplatform_v2_token, 0);

/**
 * Token 类型：决定可调用的渠道与 token 值前缀
 *
 * @generated from enum infinigence.infini.agentplatform.v2.TokenType
 */
export enum TokenType {
  /**
   * 未指定
   *
   * @generated from enum value: TOKEN_TYPE_UNSPECIFIED = 0;
   */
  TOKEN_TYPE_UNSPECIFIED = 0,

  /**
   * API 调用 token，前缀 agt_
   *
   * @generated from enum value: API = 1;
   */
  API = 1,

  /**
   * WebSocket 渠道 token，前缀 wst_
   *
   * @generated from enum value: WEBSOCKET = 2;
   */
  WEBSOCKET = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v2.TokenType.
 */
export const TokenTypeSchema: GenEnum<TokenType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v2_token, 0);

/**
 * Token 状态
 *
 * @generated from enum infinigence.infini.agentplatform.v2.TokenStatus
 */
export enum TokenStatus {
  /**
   * 未指定
   *
   * @generated from enum value: TOKEN_STATUS_UNSPECIFIED = 0;
   */
  TOKEN_STATUS_UNSPECIFIED = 0,

  /**
   * 启用
   *
   * @generated from enum value: ENABLED = 1;
   */
  ENABLED = 1,

  /**
   * 禁用
   *
   * @generated from enum value: DISABLED = 2;
   */
  DISABLED = 2,

  /**
   * 过期
   *
   * @generated from enum value: EXPIRED = 3;
   */
  EXPIRED = 3,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v2.TokenStatus.
 */
export const TokenStatusSchema: GenEnum<TokenStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v2_token, 1);

